import { useEffect } from 'react'

export default function useDocumentTitle(title: string, deps: any[] = []) {
  if (!import.meta.env.VITE_SENTRY_ENVIRONMENT) {
    title = `[Local] ${title}`
  } else if (import.meta.env.VITE_SENTRY_ENVIRONMENT === 'staging') {
    title = `[Staging] ${title}`
  }

  useEffect(() => {
    document.title = title
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, title])
}
